import React, { useState, useCallback, useContext, useEffect, useRef } from "react";
import { useParams, useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import { makeStyles } from "@material-ui/core/styles";
import TicketsManager from "../../components/TicketsManagerTabs";
import Ticket from "../../components/Ticket";

import { QueueSelectedProvider } from "../../context/QueuesSelected/QueuesSelectedContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import api from "../../services/api";
import { CircularProgress } from "@material-ui/core";
import { getBackendUrl } from "../../config";
import logo from "../../assets/cchat-logo-transparent.png";
import logoDark from "../../assets/cchat-logo-transparent-dark.png";

const defaultTicketsManagerWidth = 420;
const minTicketsManagerWidth = 360;
const maxTicketsManagerWidth = 480;

const clampTicketsManagerWidth = (value) => {
	const width = Number(value) || defaultTicketsManagerWidth;
	return Math.min(Math.max(width, minTicketsManagerWidth), maxTicketsManagerWidth);
};

const useStyles = makeStyles((theme) => ({
	chatContainer: {
		flex: 1,
		padding: theme.spacing(1.5),
		height: `calc(100% - 48px)`,
		overflowY: "hidden",
		background: theme.mode === "light" ? "#f4f7fb" : "#424242",
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1),
		},
	},
	chatPapper: {
		display: "flex",
		height: "100%",
		gap: theme.spacing(1.5),
		minWidth: 0,
	},
	contactsWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexShrink: 0,
		overflowY: "hidden",
		position: "relative",
		borderRadius: 8,
		background: theme.mode === "light" ? "#ffffff" : "#2f2f2f",
		border: theme.mode === "light" ? "1px solid #d9e2ef" : "1px solid rgba(255,255,255,0.08)",
		boxShadow: theme.mode === "light" ? "0 14px 34px rgba(15, 23, 42, 0.08)" : "0 18px 42px rgba(0,0,0,0.18)",
	},
	messagesWrapper: {
		display: "flex",
		height: "100%",
		flexDirection: "column",
		flexGrow: 1,
		minWidth: 0,
		borderRadius: 8,
		overflow: "hidden",
		background: theme.mode === "light" ? "#ffffff" : "#2b2b2b",
		border: theme.mode === "light" ? "1px solid #d9e2ef" : "1px solid rgba(255,255,255,0.08)",
		boxShadow: theme.mode === "light" ? "0 14px 34px rgba(15, 23, 42, 0.08)" : "0 18px 42px rgba(0,0,0,0.18)",
	},
	welcomeMsg: {
		background: theme.mode === "light" ? "linear-gradient(135deg, #ffffff 0%, #eef5ff 100%)" : "#2f2f2f",
		color: theme.mode === "light" ? "#142033" : "#f8fafc",
		display: "flex",
		justifyContent: "space-evenly",
		alignItems: "center",
		height: "100%",
		textAlign: "center",
		border: 0,
		fontWeight: 700,
	},
	dragger: {
		width: "6px",
		cursor: "ew-resize",
		padding: "4px 0 0",
		borderTop: 0,
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		zIndex: 100,
		backgroundColor: theme.mode === "light" ? "#e6edf6" : "#3a3a3a",
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
		userSelect: "none", // Evita a seleção de texto no elemento de redimensionamento
	},
	logo: {
		logo: theme.logo,
		content: "url(" + (theme.mode === "light" ? theme.calculatedLogoLight() : theme.calculatedLogoDark()) + ")"
	},
}));

const TicketsCustom = () => {
	const { user } = useContext(AuthContext);

	const classes = useStyles();

	const { ticketId } = useParams();

	const [ticketsManagerWidth, setTicketsManagerWidth] = useState(defaultTicketsManagerWidth);
	const ticketsManagerWidthRef = useRef(ticketsManagerWidth);
	const contactsWrapperRef = useRef(null);

	useEffect(() => {
		const nextWidth = clampTicketsManagerWidth(user?.defaultTicketsManagerWidth);
		ticketsManagerWidthRef.current = nextWidth;
		setTicketsManagerWidth(nextWidth);
	}, [user]);

	// useEffect(() => {
	// 	if (ticketId && currentTicket.uuid === undefined) {
	// 		history.push("/tickets");
	// 	}
	// }, [ticketId, currentTicket.uuid, history]);

	const handleMouseDown = (e) => {
		document.addEventListener("mouseup", handleMouseUp, true);
		document.addEventListener("mousemove", handleMouseMove, true);
	};
	const handleSaveContact = async value => {
		const width = clampTicketsManagerWidth(value);
		await api.put(`/users/toggleChangeWidht/${user.id}`, { defaultTicketsManagerWidth: width });

	}
	const handleMouseMove = useCallback(
		(e) => {
			const wrapperLeft = contactsWrapperRef.current?.getBoundingClientRect().left || 0;
			const newWidth = e.clientX - wrapperLeft;
			if (
				newWidth > minTicketsManagerWidth &&
				newWidth < maxTicketsManagerWidth
			) {
				const width = clampTicketsManagerWidth(newWidth);
				ticketsManagerWidthRef.current = width;
				setTicketsManagerWidth(width);
			}
		},
		[]
	);

	const handleMouseUp = async () => {
		document.removeEventListener("mouseup", handleMouseUp, true);
		document.removeEventListener("mousemove", handleMouseMove, true);

		const newWidth = ticketsManagerWidthRef.current;

		if (newWidth !== ticketsManagerWidth) {
			await handleSaveContact(newWidth);
		}
	};

	return (
		<QueueSelectedProvider>
			<div className={classes.chatContainer}>
				<div className={classes.chatPapper}>
					<div
						ref={contactsWrapperRef}
						className={classes.contactsWrapper}
						style={{
							width: ticketsManagerWidth,
							flexBasis: ticketsManagerWidth,
							minWidth: minTicketsManagerWidth,
							maxWidth: maxTicketsManagerWidth,
						}}
					>
						<TicketsManager />
						<div onMouseDown={e => handleMouseDown(e)} className={classes.dragger} />
					</div>
					<div className={classes.messagesWrapper}>
						{ticketId ? (
							<>
								{/* <Suspense fallback={<CircularProgress />}> */}
								<Ticket />
								{/* </Suspense> */}
							</>
						) : (
							<Hidden only={["sm", "xs"]}>
								<Paper square variant="outlined" className={classes.welcomeMsg}>
									<span>
										<center>
											<img className={classes.logo} width="50%" alt="" />
										</center>
										{i18n.t("chat.noTicketMessage")}
									</span>								</Paper>
							</Hidden>
						)}
					</div>
				</div>
			</div>
		</QueueSelectedProvider>
	);
};

export default TicketsCustom;
